Selectize.define('infinite_scroll', function(opts) {
    var self = this;

    self._state = {
        total: null,
        loading: false,
        previousContentHeight: 0,
    };

    this.setup = (function() {
        var original = self.setup;

        return function() {
            original.apply(this, arguments);
            var dropdown_content = self.$dropdown_content;


            self.on('type', function (query) {
                // debounce(function() {
                    self.settings.maxOptions = original_maxOptions;
                    options.start = 0;
                    self._state.currentQuery = query;
                    self._state.previousContentHeight = 0 ;
                    self.clearOptions();
                    self.refreshOptions(false);
                    if (query.length > 0) {
                        insertLoadingDom();
                    } else {
                        removeLoadingDom();
                    }
                    removeFullyLoadedDom();
                    self.onSearchChange({
                        search: query,
                        skip: options.start,
                        take: options.scrollStep,
                        time: (new Date()).getTime(),
                    });

                    // self.refreshOptions();
                    // self.trigger('load');
                    // options.start = 0;
                    // // removeFullyLoadedDom();
                    // // insertLoadingDom();
                    // self._state.total = 0;
                    // self.settings.maxOptions = original_maxOptions;
                    // // self.refreshOptions();
                    // var promise = self.settings.load({
                    //     search: query || '',
                    //     skip: options.start,
                    //     take: options.scrollStep,
                    // });
                    // // execPromise(promise);

                // }, 600);
            });

            self.on('load', function() {
               console.log('self.onload');
                self._state.loading = false;
                var dropdown_content = self.$dropdown_content;
                dropdown_content.scrollTop(self._state.previousContentHeight - dropdown_content.innerHeight());
                console.log(self.options);
                loadFullyLoaded();
                removeLoadingDom();
            });

            self.on('option_clear', function() {
                console.log('option clear');
                self.currentResults.items = [];
            });

            function insertLoadingDom() {
                var loadingTemplate = $('<div />').wrap('<div />');
                loadingTemplate.addClass(options.loadingTemplateClass);
                loadingTemplate.append(options.loading_template);
                self.$dropdown_content.after(loadingTemplate.parent().html());
            }

            function loadFullyLoaded() {
                if (self._state.total <=  (options.start + options.scrollStep) && self._state.total > 0) {
                    insertFullyLoadedDom();
                }
            }

            function insertFullyLoadedDom() {
                removeFullyLoadedDom();
                var loadingTemplate = $('<div />').wrap('<div />');
                loadingTemplate.addClass(options.fullyLoadedTemplateClass);
                loadingTemplate.append(options.fully_loaded_template);
                self.$dropdown_content.after(loadingTemplate.parent().html());
            }

            function removeFullyLoadedDom() {
                self.$dropdown_content.parent().find('.' + options.fullyLoadedTemplateClass).remove();
            }

            function removeLoadingDom() {
                self.$dropdown_content.parent().find('.' + options.loadingTemplateClass).remove();
            }
        };
    })();
});